import React, { useEffect } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'

const useStyles = makeStyles((theme) => ({
    preSiteFooter: {
        padding: '20px 30px',
        borderTop: '1px solid #D1D1D1',
        borderBottom: '1px solid #D1D1D1',
        backgroundColor: '#FFFFFF',
    },
    preSiteFooterInner: {
        margin: '0 auto',
        maxWidth: 1200,
        display: 'flex',
        justifyContent: 'space-between',
    },
    preSiteFooterLeft: {
        fontSize: '1rem',
        flexGrow: 1,
        display: 'block',
        margin: '0 -20px',
        '& >div': {
            alignItems: 'center',
            display: 'flex',
            marginLeft: '1rem',
            '& a': {
                padding: '10px 20px 10px 4px',
                color: '#222222',
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline',
                },
            },
        },
        [theme.breakpoints.up('md')]: {
            display: 'flex ',
        },
    },
    siteFooter: {
        background: '#FFFFFF',
        padding: '0 20px 30px',
        margin: '0 auto',
        '& a': {
            display: 'block',
            color: '#222222',
            padding: '10px 0',
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    },
    siteFooterRow: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: 1280,
        margin: '0 auto',
        paddingTop: 20,
        paddingBottom: 10,
        '&:after': {
            display: 'none',
        },
        '&:last-of-type': {
            paddingBottom: 0,
        },
        [theme.breakpoints.up('md')]: {
            flexWrap: 'nowrap',
        },
    },
    siteFooterCol: {
        width: '100%',
        float: 'none',
        flexGrow: 1,
        fontSize: '1rem',
        [theme.breakpoints.up('md')]: {
            width: '50%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '33.3333%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '50%',
        },
    },
    siteFooterTitle: {
        display: 'block',
        color: '#222222',
        marginBottom: '.9rem',
        marginTop: '1.7rem',
        fontSize: '1.13rem',
        fontWeight: 600,
        textTransform: 'uppercase',
    },
    siteFooterAppColumn: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexGrow: 0,
        flexWrap: 'wrap',
        paddingTop: 30,
        '& img': {
            maxHeight: 40,
            marginTop: 5,
            '&:first-of-type': {
                marginTop: 0,
            },
        },
        [theme.breakpoints.up('md')]: {
            textAlign: 'right',
            alignSelf: 'flex-end',
            display: 'block',
            '& >div': {
                padding: 0,
            },
        },
    },
    footerLegalLinks: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        marginTop: 20,
        padding: 0,
        '& span': {
            padding: '4px 10px',
            display: 'block',
        },
    },
    copyrightText: {
        fontSize: '1rem',
        color: '#6F6F6F',
        '& a': {
            color: '#6F6F6F',
            textDecoration: 'none',
            padding: '4px 10px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    },
    siteFooterBadges: {
        display: 'flex',
        flexGrow: 0,
        margin: '0 -20px',
        width: 'auto',
        '& >div': {
            padding: '0 20px',
            '& a': {
                display: 'block',
            },
        },
        [theme.breakpoints.up('md')]: {
            display: 'block',
            paddingLeft: '1rem',
        },
        '& #site-footer-digicert-container': {
            padding: '10px 0',
        },
    },
    visaFooterDisclaimer: {
        maxWidth: 1200,
        margin: '0 auto 1em',
        flexGrow: 1,
        fontSize: '0.9rem',
        color: '#6F6F6F',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.9rem',
        },
    },
    bbbImg: {
        border: 0,
        maxHeight: 63,
    },
    lazyLoaded: {
        opacity: 1,
        transition: 'opacity 300ms',
    },
}))

const Footer = ({ baseUrl }) => {
    const classes = useStyles()

    useEffect(() => {
        const script = document.createElement('script')
        script.text = `var __dcid = __dcid || [];__dcid.push(["DigiCertClickID_6QFMUaLr", "15", "s", "black", "6QFMUaLr"]);(function(){var cid=document.createElement("script");cid.async=true;cid.src="//seal.digicert.com/seals/cascade/seal.min.js";var s = document.getElementsByTagName("script");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());`
        if (document.body) document.body.appendChild(script)
    }, [])

    return (
        <>
            <div className={classes.preSiteFooter}>
                <div className={classes.preSiteFooterInner}>
                    <div className={classes.preSiteFooterLeft}>
                        <div>
                            <ChatBubbleOutlineOutlinedIcon />
                            <a href={`${baseUrl}/bulk-gift-cards/`}>
                                Get a bulk quote
                            </a>
                        </div>
                        <div>
                            <SearchOutlinedIcon />
                            <a href={`${baseUrl}/gift-card-balance-check/`}>
                                Check a gift card balance
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <footer className={`${classes.siteFooter}`}>
                <Grid container className={classes.siteFooterRow}>
                    <Grid item sm={12} md={3} className={classes.siteFooterCol}>
                        <span className={classes.siteFooterTitle}>Shop</span>
                        <a
                            href={`${baseUrl}/buy-gift-cards/visa/`}
                            data-layer-push-event="FooterClick|Footer|Click|Visa"
                        >
                            Visa Gift Cards
                        </a>
                        <a
                            href={`${baseUrl}/buy-gift-cards/mastercard/`}
                            data-layer-push-event="FooterClick|Footer|Click|Mastercard"
                        >
                            Mastercard Gift Cards
                        </a>
                        <a
                            href={`${baseUrl}/buy-gift-cards/`}
                            data-layer-push-event="FooterClick|Footer|Click|National brands"
                        >
                            National Brands
                        </a>
                        <a
                            href={`${baseUrl}/buy-local-gift-cards/`}
                            data-layer-push-event="FooterClick|Footer|Click|Local brands"
                        >
                            Local Gift Cards
                        </a>
                        <a
                            href="https://www.giftya.com"
                            data-layer-push-event="FooterClick|Footer|Click|GiftYa"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            GiftYa
                        </a>
                        <a
                            href={`${baseUrl}/bulk-gift-cards/`}
                            data-layer-push-event="FooterClick|Footer|Click|Corporate bulk"
                        >
                            Buy in bulk
                        </a>
                        <a
                            href={`${baseUrl}/free-gift-cards/`}
                            data-layer-push-event="FooterClick|Footer|Click|Earn rewards"
                        >
                            Earn rewards
                        </a>
                    </Grid>
                    <Grid item sm={12} md={3} className={classes.siteFooterCol}>
                        <span className={classes.siteFooterTitle}>
                            About Us
                        </span>
                        <a
                            href={`${baseUrl}/about/`}
                            data-layer-push-event="FooterClick|Footer|Click|Our Story"
                        >
                            Our story
                        </a>
                        <a
                            href={`${baseUrl}/press/`}
                            data-layer-push-event="FooterClick|Footer|Click|Press & media"
                        >
                            Press & media
                        </a>
                        <a
                            href={`${baseUrl}/reviews/`}
                            data-layer-push-event="FooterClick|Footer|Click|Reviews"
                        >
                            Reviews
                        </a>
                        <a
                            href={`${baseUrl}/trae-bodge/`}
                            data-layer-push-event="FooterClick|Footer|Click|Trae Bodge spokesperson"
                        >
                            Our spokesperson, Trae Bodge
                        </a>
                        <a
                            href={`${baseUrl}/press/gift-card-research/`}
                            data-layer-push-event="FooterClick|Footer|Click|Research & Trends"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            Research & Trends
                        </a>
                        <a
                            href={`${baseUrl}/blog/`}
                            data-layer-push-event="FooterClick|Footer|Click|Money Saving Blog"
                        >
                            Blog
                        </a>
                    </Grid>
                    <Grid item sm={12} md={3} className={classes.siteFooterCol}>
                        <span className={classes.siteFooterTitle}>Support</span>
                        <a
                            href={`${baseUrl}/activate/`}
                            data-layer-push-event="FooterClick|Footer|Click|Activate a card"
                        >
                            Activate a Visa or Mastercard
                        </a>
                        <a
                            href={`${baseUrl}/check-balance/`}
                            data-layer-push-event="FooterClick|Footer|Click|Check a gift card balance"
                        >
                            Check Balance on a Visa or Mastercard
                        </a>
                        <a
                            href={`${baseUrl}/orderstatus/`}
                            data-layer-push-event="FooterClick|Footer|Click|Order status"
                        >
                            Order status
                        </a>
                        <a
                            href={`${baseUrl}/contact/`}
                            data-layer-push-event="FooterClick|Footer|Click|FAQs"
                        >
                            FAQ's
                        </a>
                        <a
                            href={`${baseUrl}/contact/`}
                            data-layer-push-event="FooterClick|Footer|Click|Contact us"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            Customer Service
                        </a>
                        <a
                            href={`${baseUrl}/sitemap/`}
                            data-layer-push-event="FooterClick|Footer|Click|Sitemap"
                        >
                            Sitemap
                        </a>
                    </Grid>
                    <Grid item sm={12} md={3} className={classes.siteFooterCol}>
                        <span className={classes.siteFooterTitle}>
                            Follow Us
                        </span>
                        <a
                            href="https://www.facebook.com/GiftCardGranny"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            Facebook
                        </a>
                        <a
                            href="https://www.instagram.com/giftcard_granny/"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            Instagram
                        </a>
                        <a
                            href="https://twitter.com/giftcardgranny"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            Twitter
                        </a>
                        <a
                            href="https://www.linkedin.com/company/gift-card-granny-llc/"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            LinkedIn
                        </a>
                        <a
                            href="https://www.youtube.com/channel/UChf3CH5jTxhr_c-R2rOVEXA/"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            YouTube
                        </a>
                    </Grid>
                    <div
                        className={`${classes.siteFooterCol} ${classes.siteFooterAppColumn}`}
                    >
                        <div>
                            <a
                                href="https://itunes.apple.com/app/apple-store/id703155858?pt=117789344&amp;ct=store-pages&amp;mt=8"
                                target="_blank"
                                data-app-store="iTunes"
                                rel="noreferrer noopener"
                                data-layer-push-event="FooterClick|Footer|Click|Apple App Store"
                            >
                                <img
                                    className={classes.lazyLoaded}
                                    src="https://marketingcdn.giftcardgranny.com/App+Resources/gcg-app-apple-app-store.png"
                                    alt="Apple App Store"
                                    width="120"
                                    height="40"
                                    loading="lazy"
                                />
                            </a>
                            <a
                                href="https://itunes.apple.com/app/apple-store/id703155858?pt=117789344&amp;ct=store-pages&amp;mt=8"
                                target="_blank"
                                data-app-store="Google Play"
                                rel="noreferrer noopener"
                                data-layer-push-event="FooterClick|Footer|Click|Google Play Store"
                            >
                                <img
                                    className={classes.lazyLoaded}
                                    src="https://marketingcdn.giftcardgranny.com/2019/footer/badge-android.png"
                                    alt="Google Play Store"
                                    width="120"
                                    height="40"
                                    loading="lazy"
                                />
                            </a>
                        </div>
                    </div>
                </Grid>
                <div
                    className={`${classes.footerLegalLinks} ${classes.siteFooterRow} ${classes.copyrightText}`}
                >
                    <div>
                        <span>
                            &copy; {new Date().getFullYear()} Gift Card Granny
                            LLC
                        </span>
                    </div>
                    <div>
                        <a
                            href={`${baseUrl}/terms/`}
                            data-layer-push-event="FooterClick|Footer|Click|Terms"
                        >
                            Terms &amp; conditions
                        </a>
                    </div>
                    <div>|</div>
                    <div>
                        <a
                            href={`${baseUrl}/privacy-policy/`}
                            data-layer-push-event="FooterClick|Footer|Click|Privacy Policy"
                        >
                            Privacy policy
                        </a>
                    </div>
                    <div>|</div>
                    <div>
                        <a
                            href={`${baseUrl}/refund-return-policy/`}
                            data-layer-push-event="FooterClick|Footer|Click|Refund Return Policy"
                        >
                            Refund &amp; Return policy
                        </a>
                    </div>
                </div>
                <div className={`${classes.siteFooterRow}`}>
                    <div className={`${classes.siteFooterCol}`}>
                        <p
                            className={classes.visaFooterDisclaimer}
                            data-sutton-terms
                        >
                            The Gift Card Granny Visa® Gift Card and the Virtual
                            Visa Gift Card are issued by Sutton Bank®, Member
                            FDIC, pursuant to a license from Visa U.S.A. Inc.
                            The Visa Gift Card can be used everywhere Visa debit
                            cards are accepted in the US. No cash or ATM access.
                            The Virtual Visa Gift Card can be redeemed at
                            internet merchants everywhere Visa debit cards are
                            accepted in the US. No cash or ATM access. The Gift
                            Card Granny Mastercard® Gift Card and Mastercard
                            Virtual Gift Card are issued by Sutton Bank, Member
                            FDIC, pursuant to a license by Mastercard
                            International Incorporated. Use your Mastercard Gift
                            Card and Mastercard Virtual Gift Card everywhere
                            Debit Mastercard is accepted in the US. Mastercard
                            is a registered trademark, and the circles design is
                            a trademark of Mastercard International
                            Incorporated.
                        </p>
                    </div>
                    <div
                        className={`${classes.siteFooterCol} ${classes.siteFooterBadges}`}
                    >
                        <div>
                            <div id="site-footer-digicert-container">
                                <div
                                    id="DigiCertClickID_6QFMUaLr"
                                    data-language="en"
                                    className="{% if systemParam('digicert_test_class_enabled') == 1 %}allow-test-seal{% endif %}"
                                ></div>
                            </div>
                        </div>
                        <div>
                            <a
                                href="https://www.bbb.org/us/pa/pittsburgh/profile/gift-cards/gift-card-granny-0141-71025047/#sealclick"
                                target="_blank"
                                rel="noreferrer noopener noreferrer"
                            >
                                <img
                                    className={`${classes.bbbImg} ${classes.lazyLoaded}`}
                                    loading="lazy"
                                    src="https://seal-westernpennsylvania.bbb.org/seals/blue-seal-120-61-bbb-71025047.png"
                                    alt="Gift Card Granny BBB Business Review"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
